import React, { useState } from "react";
import { Table } from "antd";
import { computeRowsAndColsForTransactions } from "../../utils/functions";
import { ChargerTransactions } from "pages/chargers/Charger";
import "./ChargerTransactionsTable.less"
import useWindowDimensions from "common/functions";
import { Modal } from 'antd';

interface ITable {
	data: ChargerTransactions
	setNewSort: (value: string) => void;
	offset: number;
	setOffset: (value: number) => void;
	limit: number; 
	length: number;
}

const ChargersTransactionsTable: React.FC<ITable> = ({
	data,
	setNewSort,
	offset,
	setOffset,
	limit,
	length
}) => {

	const [isAsc, setIsAsc] = useState({
		startTime: false,
		endTime: false,
		length: false,
		energy: false,
	});
	const [isDesc, setIsDesc] = useState({
		startTime: false,
		endTime: false,
		length: false,
		energy: false,
	});

	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentTransaction, setCurrentTransaction] = useState(null);

	const { columns, rows } = computeRowsAndColsForTransactions(
		data,
		(value) => setNewSort(value),
		isAsc,
		isDesc,
		(value) => setIsAsc(value),
		(value) => setIsDesc(value),
		(value) => setCurrentTransaction(value),
		(value) => setIsModalVisible(value),
	);

	const { width } = useWindowDimensions();

	return (
		<>
		<Table columns={columns} dataSource={rows} size={width > 1200 ? 'large' : 'small'}
			scroll={{ x: 500 }}
			pagination={{
				total: length,
				current: offset + 1,
				onChange: (page) => setOffset(page - 1),
				defaultPageSize: limit,
				showSizeChanger: false
			}}
			bordered />
			<Modal
			title="Transaction Details"
			visible={isModalVisible}
			onOk={() => setIsModalVisible(false)}
			onCancel={() => setIsModalVisible(false)}
			>
			<div style={{ padding: '20px', backgroundColor: '#f7f7f7', borderRadius: '8px' }}>
				<p style={{ marginBottom: '10px', color: '#333' }}>
				<strong>Transaction ID: </strong> {currentTransaction ? currentTransaction['transactionId'] : "N/A"}
				</p>
				<p style={{ marginBottom: '10px', color: '#333' }}>
				<strong>Session Duration: </strong> {currentTransaction ? currentTransaction['sessionLength'] : 0} mins
				</p>
				<p style={{ marginBottom: '10px', color: '#333' }}>
				<strong>Charging Duration: </strong> {currentTransaction ? currentTransaction['chargingLength'] : 0} mins
				</p>
				<p style={{ marginBottom: '10px', color: '#333' }}>
				<strong>Started By: </strong> {currentTransaction ? currentTransaction['startedBy'] : "N/A"}
				</p>
				<p style={{ marginBottom: '10px', color: '#333' }}>
				<strong>Stopped By: </strong> {currentTransaction ? currentTransaction['stoppedBy'] : "N/A"}
				</p>
			</div>
			</Modal>
			</>
	);
};

export default ChargersTransactionsTable;
